var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notfound-page"},[_c('img',{attrs:{"src":require("@/assets/img/404.jpg"),"alt":"找不到页面"}}),_c('p',{staticClass:"sorry"},[_vm._v(" "+_vm._s(_vm.message)),(_vm.newUrl)?_c('a',{staticClass:"new-url",attrs:{"href":_vm.newUrl}},[_vm._v(_vm._s(_vm.newUrl))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }